import { requestEdgeFunction } from './edgeFunctionClient';

export type InsertStorageFileParams = {
  bucketId: string;
  folderPath: string;
  fileName: string;
  contentType?: string | null;
  sizeBytes?: number | null;
  ownerType?: string | null;
  ownerId?: string | number | null;
  fileKind?: string | null;
  uploadedByUserId?: string | null;
};

const splitStoragePath = (storagePath: string): { folderPath: string; fileName: string } => {
  const normalized = storagePath.replace(/^\/+|\/+$/g, '');
  const slashIndex = normalized.lastIndexOf('/');

  if (slashIndex <= 0) {
    return { folderPath: '', fileName: normalized };
  }

  return {
    folderPath: normalized.slice(0, slashIndex),
    fileName: normalized.slice(slashIndex + 1),
  };
};

/** Registra upload de imagem no catálogo `storage_files` via RPC. */
export async function insertStorageFile(params: InsertStorageFileParams): Promise<void> {
  const folderPath = params.folderPath.replace(/^\/+|\/+$/g, '');
  const fileName = params.fileName.trim();

  if (!params.bucketId.trim() || !fileName) {
    return;
  }

  await requestEdgeFunction('upload-student-photo', {
    method: 'POST',
    body: {
      action: 'register-storage-file',
      bucketId: params.bucketId,
      storagePath: `${folderPath}/${fileName}`.replace(/^\/+/, ''),
      contentType: params.contentType ?? null,
      sizeBytes: params.sizeBytes ?? null,
      ownerType: params.ownerType ?? null,
      ownerId: params.ownerId == null ? null : String(params.ownerId),
      fileKind: params.fileKind ?? null,
      uploadedByUserId: params.uploadedByUserId ?? null,
    },
  }).catch((error) => {
    console.warn('[storage_files] register-storage-file failed', error);
  });
}

export async function insertStorageFileByPath(
  params: Omit<InsertStorageFileParams, 'folderPath' | 'fileName'> & { storagePath: string },
): Promise<void> {
  const { folderPath, fileName } = splitStoragePath(params.storagePath);
  await insertStorageFile({
    ...params,
    folderPath,
    fileName,
  });
}

/** Soft-delete de registro em `storage_files` via RPC. */
export async function softDeleteStorageFileByPath(params: {
  bucketId: string;
  storagePath: string;
}): Promise<void> {
  if (!params.bucketId.trim() || !params.storagePath.trim()) {
    return;
  }

  await requestEdgeFunction('upload-student-photo', {
    method: 'POST',
    body: {
      action: 'soft-delete-storage-file',
      bucketId: params.bucketId,
      storagePath: params.storagePath,
    },
  }).catch((error) => {
    console.warn('[storage_files] soft-delete-storage-file failed', error);
  });
}

